import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getInvoices } from "../apis/invoiceSlice";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";

export default function InvoiceList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { invoices } = useSelector((state) => state.invoiceData);
  const { loggedIn } = useSelector((state) => state.authData);

  useEffect(() => {
    if (loggedIn?._id) {
      dispatch(getInvoices({ uId: loggedIn?._id, page: 0, pageSize: 10 }));
    }
  }, [loggedIn]);
  const invoiceTypes = {
    K: "Cash",
    C: "Credit",
    U: "Uchak",
  };
  return (
    <div className="p-3">
      <Button
        icon={"pi pi-home"}
        className="h-[3rem] m-2"
        onClick={() => navigate("/")}
      />
      {invoices.map((item, index) => {
        return (
          <div
            key={index}
            className="border-2 border-gray-300 p-3 m-2 rounded-md shadow-md"
            onClick={() => navigate(`/editinvoice/${item._id}`)}
          >
            <div className="flex items-center gap-2">
              <h1 className="text-lg font-bold">{item.billNo}</h1>
              {item?.invoice_type && (
                <Tag
                  value={`${invoiceTypes[item?.invoice_type]}`}
                  className="p-1"
                ></Tag>
              )}
            </div>
            <p>Total = {item.totalAmt}</p>
          </div>
        );
      })}
    </div>
  );
}
